import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Sparkles, Loader2 } from 'lucide-react';
import { JourneyInterview } from '../training-journey/JourneyInterview';
import { fetchConfig, recommend, saveJourney, errMsg } from '../training-journey/journeyApi';

/** Homepage mini-quiz — same questions as the page; hands the runner to
 *  /online-training-plan with the recommendation ready. */
export const InlineTrainingQuiz = () => {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { fetchConfig().then(setConfig).catch(() => setConfig(false)); }, []);

  const complete = async (answers) => {
    setBusy(true);
    try {
      const res = await recommend(answers, 'homepage');
      saveJourney({ interview: res, token: res.offer_token });
      navigate(`/online-training-plan?interview=${res.interview_id}#training-plan-form`);
    } catch (e) { toast.error(errMsg(e, 'Could not work out a recommendation. Please try again.')); setBusy(false); }
  };

  if (config === false) return null;
  return (
    <div className="rounded-2xl bg-white border border-[#EDE9FE] p-5 md:p-6 h-full flex flex-col" style={{ boxShadow: '0 8px 32px -12px rgba(168, 85, 247, 0.15)' }} data-testid="home-training-quiz">
      <div className="inline-flex items-center gap-1.5 self-start px-2.5 py-1 rounded-full bg-[#F5F3FF] border border-[#E9D5FF] text-[10px] font-black uppercase tracking-widest text-[#7E22CE] mb-3">
        <Sparkles size={11} /> Which plan suits you?
      </div>
      <h3 className="text-xl font-black tracking-tight text-[#0F172A] mb-1">Find your best training plan</h3>
      <p className="text-xs text-slate-500 mb-4">Six quick questions — we'll recommend the package that fits your experience, goal, schedule and budget.</p>
      {!config ? <Loader2 size={22} className="animate-spin text-[#A855F7] mx-auto my-8" /> : (
        <JourneyInterview questions={config.questions} onComplete={complete} busy={busy} compact />
      )}
    </div>
  );
};
